import reportErrorSentry from "./reportErrorSentry";

export const HUBSPOT_FINGERPRINT_KEY = "__hsfp";
export const HUBSPOT_FINGERPRINT_ORIGINAL_KEY = "original";

export function parseHubspotFingerprint(
  queryParams: URLSearchParams
): URLSearchParams {
  const hijackedHsfpEncoded = queryParams.get(HUBSPOT_FINGERPRINT_KEY);

  if (!hijackedHsfpEncoded) {
    return queryParams;
  }

  let payloadString: string;
  try {
    payloadString = decodeURIComponent(hijackedHsfpEncoded);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error decoding __hsfp parameter:", error);
    reportErrorSentry(error);
    return queryParams;
  }

  if (
    payloadString.length === 0 ||
    // payload is the same as the original query params
    queryParams.toString().includes(payloadString)
  ) {
    return queryParams;
  }

  const found = new URLSearchParams(queryParams.toString());
  found.delete(HUBSPOT_FINGERPRINT_KEY);

  try {
    const payloadParams = new URLSearchParams(payloadString);

    for (const [key, value] of payloadParams) {
      if (key === HUBSPOT_FINGERPRINT_ORIGINAL_KEY) {
        const originalValue = payloadParams.get(
          HUBSPOT_FINGERPRINT_ORIGINAL_KEY
        );
        if (originalValue !== null) {
          found.set(HUBSPOT_FINGERPRINT_KEY, originalValue);
        }
      } else {
        found.set(key, value);
      }
    }

    const newUrl = `${window.location.pathname}?${found.toString()}${window.location.hash}`;
    window.history.replaceState({}, "", newUrl);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error processing __hsfp payload or updating URL:", error);
    reportErrorSentry(error);
    return new URLSearchParams();
  }

  return found;
}
